<template>
  <div class="navigation-items-fi">
    <div
      v-for="group in navigationGroups"
      :key="group.id"
      :class="{
        'navigation-items-fi__group': true,
        'navigation-items-fi__no-label': !group.groupLabel,
      }"
    >
      <span
        v-if="group.groupLabel"
        class="navigation-items-fi__group-label"
        >{{ group.groupLabel }}
      </span>
      <ul class="navigation-items-fi__list">
        <li
          v-for="item in group.groupList"
          :key="item.id"
          class="navigation-items-fi__list-item"
        >
          <a
            :href="item.url"
            :target="item.target || undefined"
            :rel="item.target === '_blank' ? 'noopener noreferrer' : undefined"
            :data-test-2="item.label"
            data-test="navigation-group"
            class="navigation-items-fi__list-item--link"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useNavigation } from '@/composables/navigation';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'NavigationItemsFi' });

const navigationStore = useNavigationStore();
const { getNavigationGroups } = useNavigation();

const subElements = computed(() => navigationStore.subElements);

const navigationGroups = computed(() => getNavigationGroups(subElements.value));
</script>

<style scoped src="./navigation-items-fi" />
